export const routeTitles: Readonly<Record<string, string>> = {
  "/kurulum": "Kurulum",
  "/giris": "Giriş",
  "/giris/iki-adim": "İki adımlı doğrulama",
  "/genel-bakis": "Genel Bakış",
  "/projeler": "Projeler",
  "/sunucular": "Sunucular",
  "/veritabanlari": "Veritabanları",
  "/ekip": "Ekip",
  "/ayarlar/api-anahtarlari": "API Anahtarları",
  "/ayarlar/guvenlik": "Güvenlik",
  "/ayarlar/saglayicilar": "Sağlayıcılar",
  "/ayarlar/operasyon": "Operasyon ayarları",
  "/denetim-kaydi": "Denetim Kaydı",
  "/yetki-yok": "Yetki yok",
};

export function titleForPath(pathname: string): string {
  return routeTitles[pathname] ?? "Sayfa bulunamadı";
}

export function usePageTitle(title: string): void {
  useEffect(() => {
    document.title = `${title} · WebYönetim`;
  }, [title]);
}
import { useEffect } from "react";
